import React, { Component } from 'react';
import {Container, Row, Col , Form} from 'react-bootstrap';
import '../assets/css/GradeCal.css';
import SubjList from './SubjList';

class GradeCal extends Component {

    handleChangeCA(e){
        const ca = this.inputGP;
        let new_ca = parseFloat(ca.value);
        if(isNaN(new_ca)){
            this.setState({ca:0})
            return;
        }
        if(new_ca < 0){
            new_ca = 0;
        }
        this.setState({ca:new_ca})
    }

    handleChangeGP(e){
        const gp = this.inputGP;
        let new_gp = parseFloat(gp.value);
        if(isNaN(new_gp)){
            this.setState({gp:0})
            return;
        }
        if(new_gp < 0){
            new_gp = 0;
        }
        this.setState({gp:new_gp});
    }

    constructor(props){
        super(props);
        this.state ={
            ca:0,
            gp:0,
        };
        this.inputGP = 0
        this.inputCA = 0
    }
  render() {
    return (
      <Container>
        <Row>
            <Col md={{ span: 3, offset: 3  }} xs={{ span: 4, offset: 2  }}>
                <Form.Group>
                    <Form.Label>CA</Form.Label>
                     <Form.Control type='text' placeholder='CA' inputRef={(el) => this.inputCA = el} defaultValue={this.state.ca} onChange={this.handleChangeCA.bind(this)} autoFocus/> 
                </Form.Group>
            </Col>
            <Col md={3} xs={4}>
                <Form.Group>
                    <Form.Label>GP</Form.Label>
                    <Form.Control type='text' placeholder='GP' inputRef={(el) => this.inputGP = el} defaultValue={this.state.gp} onChange={this.handleChangeGP.bind(this)}/>
                </Form.Group>
            </Col>
        </Row>
        <hr/>
        <SubjList caValue={this.state.ca} gpValue={this.state.gp}/>
      </Container>
    );
  }
}

export default GradeCal;